import { useEffect, useState } from 'react';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { useResourceDoc } from 'new/hooks/adapters/useResourceDoc';
import { fetchDatasetDoc } from 'js/actions';
import { GET_DATA_SET_DOC_REQUEST } from 'js/constants/actionTypes';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';
import useAppDispatch from 'js/hooks/useAppDispatch';

export function useFetchDatasetDoc(datasetId: number) {
  const dispatch = useAppDispatch();
  const [hasRequestedDoc, setHasRequestedDoc] = useState(false);

  const isLoadingDoc = useIsLoading(GET_DATA_SET_DOC_REQUEST);
  const doc = useResourceDoc(RESOURCE_TYPE_DATA_SET, datasetId);

  useEffect(() => {
    if (!datasetId) return;
    setHasRequestedDoc(false);
    dispatch(fetchDatasetDoc(datasetId));
  }, [datasetId, dispatch]);

  useEffect(() => {
    if (isLoadingDoc) {
      setHasRequestedDoc(true);
    }
  }, [isLoadingDoc]);

  return {
    doc,
    isLoadingDoc,
    hasRequestedDoc,
  };
}
